import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl, sharedValidators } from "../../lib/shared/validators";
import { customFieldValues } from "../custom_fields";

export const salesStatus = v.union(
  v.literal("pending"),
  v.literal("completed"),
  v.literal("cancelled"),
);

export const salePaymentMethod = v.union(
  v.literal("credit_card"),
  v.literal("paypal"),
  v.literal("bank_transfer"),
  v.literal("cash"),
  v.literal("other"),
);

export const SALE_STATUSES = ["pending", "completed", "canceled"] as const;

export const saleValidator = v.object({
  // clientId/sellerId opcionales: soportan modelo de borrador (createSaleDraft).
  // Una venta finalizada siempre los tiene (lo valida el submit).
  sellerId: v.optional(v.id("sellers")),
  invoiceId: v.optional(v.id("invoices")),
  quotationId: v.optional(v.id("quotations")),
  workOrderId: v.optional(v.id("work_orders")),
  clientId: v.optional(v.id("clients")),
  code: v.optional(v.string()),
  status: v.optional(salesStatus),
  title: v.optional(v.string()),
  description: v.optional(v.string()),
  subtotal: v.optional(v.number()),
  taxAmount: v.optional(v.number()),
  totalAmount: v.optional(v.number()),
  currency: v.optional(sharedValidators.currencyValue),
  paymentMethod: v.optional(salePaymentMethod),
  exemptAmount: v.optional(v.number()),
  discountAmount: v.optional(v.number()),
  paymentTerms: v.optional(v.string()),
  notes: v.optional(v.string()),

  internalControl: internalControl,
  /** Valores de campos personalizados (Colecciones), por key de definición. */
  customFields: v.optional(customFieldValues),
});

export const sales = defineTable(saleValidator)
  .index("by_client_id", ["clientId"])
  .index("by_seller_id", ["sellerId"])
  .index("by_quotation_id", ["quotationId"])
  .index("by_work_order_id", ["workOrderId"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_branch_and_status", ["internalControl.branchId", "status"])
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_state", ["internalControl.state"])
  .index("by_company_and_state", [
    "internalControl.companyId",
    "internalControl.state",
  ])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_and_state", [
    "internalControl.branchId",
    "internalControl.state",
  ])
  .index("by_created_by", ["internalControl.createdBy"])
  .index("by_updated_by", ["internalControl.updatedBy"])
  .index("by_created_at", ["internalControl.createdAt"])
  .index("by_company_and_created_at", [
    "internalControl.companyId",
    "internalControl.createdAt",
  ])
  // Dashboard: rango de fechas dentro de una sucursal sin traer toda la sucursal.
  .index("by_company_and_branch_and_created_at", [
    "internalControl.companyId",
    "internalControl.branchId",
    "internalControl.createdAt",
  ]);
